var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"disabled":_vm.loading,"color":"green"},on:{"change":_vm.paymentConfirm},model:{value:(_vm.order.payment.confirmed),callback:function ($$v) {_vm.$set(_vm.order.payment, "confirmed", $$v)},expression:"order.payment.confirmed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }